// import Sidebar from "../components/Sidebar";
// import Topbar from "../components/Topbar";
// import { Outlet } from "react-router-dom";

// import { useReviewMode } from "../context/ReviewModeContext";

// export default function AdminLayout() {
//   const { reviewMode } = useReviewMode();

//   return (
//     <div style={styles.container}>
//       {/* SIDEBAR */}

//       {!reviewMode && <Sidebar />}

//       {/* RIGHT SECTION */}

//       <div
//         style={{
//           ...styles.right,
//           ...(reviewMode
//             ? styles.rightReviewMode
//             : {}),
//         }}
//       >
//         {!reviewMode && <Topbar />}

//         <div
//           style={{
//             ...styles.content,
//             ...(reviewMode
//               ? styles.contentReviewMode
//               : {}),
//           }}
//         >
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     display: "flex",
//     height: "100vh",
//     overflow: "hidden",
//   },

//   right: {
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//     minWidth: 0,
//   },

//   rightReviewMode: {
//     width: "100%",
//   },

//   content: {
//     flex: 1,
//     background: "#f1f5f9",
//     padding: "20px",
//     overflow: "auto",
//   },

//   contentReviewMode: {
//     padding: 0,
//     background: "#ffffff",
//   },
// };

import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "./AppShell.css";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import {
  PerformanceTrackerChromeProvider,
  PerformanceTrackerProvider,
  PerformanceTrackerWidget,
} from "../components/PerformanceTracker";
import { usePresencePing } from "../components/PerformanceTracker/usePresencePing";
import { useReviewMode } from "../context/ReviewModeContext";

export default function AdminLayout() {
  const { reviewMode } = useReviewMode();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  usePresencePing();

  // Close drawer on route change
  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  // Lock body scroll only when drawer is open (non-review mode)
  useEffect(() => {
    if (reviewMode || !isSidebarOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isSidebarOpen, reviewMode]);

  const closeSidebar = () => setIsSidebarOpen(false);
  const toggleSidebar = () => setIsSidebarOpen((open) => !open);

  return (
    <PerformanceTrackerProvider>
      <PerformanceTrackerChromeProvider>
        <div className={`app-shell ${reviewMode ? "app-shell--bare" : ""}`.trim()}>
      {!reviewMode && isSidebarOpen && (
        <button
          type="button"
          className="app-shell__backdrop"
          aria-label="Close navigation menu"
          onClick={closeSidebar}
        />
      )}

      {!reviewMode && (
        <aside
          className={`app-shell__sidebar ${
            isSidebarOpen ? "app-shell__sidebar--open" : ""
          }`}
        >
          <Sidebar onNavigate={closeSidebar} />
        </aside>
      )}

      <div className="app-shell__main">
        {!reviewMode && (
          <div className="app-shell__header">
            <Topbar onMenuToggle={toggleSidebar} isMenuOpen={isSidebarOpen} />
          </div>
        )}

        <div
          className={`app-shell__content ${
            reviewMode ? "app-shell__content--bare" : "app-shell__content--admin"
          }`.trim()}
          style={{
            background: reviewMode ? "#ffffff" : undefined,
          }}
        >
          <Outlet />
        </div>
      </div>
        <PerformanceTrackerWidget />
        </div>
      </PerformanceTrackerChromeProvider>
    </PerformanceTrackerProvider>
  );
}